// RAT binding implementation for click events
// https://confluence.rakuten-it.com/confluence/pages/viewpage.action?pageId=2617778545
const bindClickRat = (element: HTMLButtonElement | null) => {
  if (element && window.RAT) {
    window.RAT.bind(window.RAT.$Selector(element));
  }
};

export default bindClickRat;
